/**
 * Realtime channel naming.
 *
 * Regression guard: two mounted subscribers sharing a channel name collided
 * and broke the notifications page.
 */

export function newInstanceId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).slice(2);
}

/** e.g. notifications-realtime-<userId>-<instanceId> */
export function realtimeChannelName(prefix: string, scopeId: string, instanceId: string): string {
  return `${prefix}-${scopeId}-${instanceId}`;
}
